<template>
  <div class="cart__mini">
    <ul>
      <li>
        <div class="cart__title">
          <h4>Your Cart</h4>
          <span>({{ cartStore.totalPriceQuantity.quantity }} Item(s) in Cart)</span>
        </div>
      </li>
      <li v-if="cartStore.cart_products.length === 0">
        <div class="mt-20">
          <h3>Your Cart is Empty</h3>
          <router-link to="/shop" class="wc-cart mt-10 mb-10">Go to shop</router-link>
        </div>
      </li>
      <template v-if="cartStore.cart_products.length">
        <li v-for="item in cartStore.cart_products" :key="item.id">
          <div class="cart__item d-flex justify-content-between align-items-center">
            <div class="cart__inner d-flex">
              <div class="cart__thumb">
                <router-link :to="`/shop-details/${item.id}`">
                  <img :src="item.image" alt="">
                </router-link>
              </div>
              <div class="cart__details">
                <h6><router-link :to="`/shop-details/${item.id}`">{{ item.title }}</router-link></h6>
                <div class="cart__price">
                  <span>LKR {{ Number(item.price).toFixed(2) }}</span>
                </div>
              </div>
            </div>
            <div class="cart__del">
              <a href="#" @click.prevent="cartStore.removeCartProduct(item)">
                <i class="fas fa-times"></i>
              </a>
            </div>
          </div>
        </li>
        <li>
          <div class="cart__sub d-flex justify-content-between align-items-center">
            <h6>Subtotal</h6>
            <span class="cart__sub-total">
              LKR {{ cartStore.totalPriceQuantity.total.toFixed(2) }}
            </span>
          </div>
        </li>
        <li>
          <router-link to="/cart" class="wc-cart mb-10">View cart</router-link>
          <router-link to="/checkout" class="wc-checkout">Checkout</router-link>
        </li>
      </template>
    </ul>
  </div>
</template>

<script setup>
import { useCartStore } from '@/stores/useCartStore';
const cartStore = useCartStore();
</script>